"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openingSourceId = openingSourceId;
exports.checkOpeningBalance = checkOpeningBalance;
/**
 * مصدر قيد الافتتاح ثابت لكل سنة مالية — والفهرس الفريد على المصدر المنشور
 * (`uq_journals_posted_source`) يمنع بذلك افتتاحيتين لنفس السنة حتى تحت التزامن.
 */
function openingSourceId(periodStartDate) {
    return 'opening-' + periodStartDate.slice(0, 4);
}
/**
 * قواعد قيد الافتتاح — تُضاف لفحوص المحرك العادية حين `sourceType = opening_balance`،
 * أيًّا كان المسار الذى جاء منه، فلا يُتجاوز أى منها بتسمية القيد.
 *
 *  - **حسابات الميزانية وحدها:** الافتتاحية ترحّل ما بقى فى الأصول والخصوم وحقوق
 *    الملكية. رصيد إيراد أو مصروف فى الافتتاحية يعنى أن نتيجة سنة سابقة لم تُقفل
 *    إلى الأرباح المرحلة.
 *  - **تاريخها أول يوم فى الفترة:** فتظهر فى كشف أى حساب كأول حركة فى السنة.
 *  - **مصدر واحد لكل سنة** (`openingSourceId`).
 *
 * والاتزان يفحصه المحرك كأى قيد. قيد غير متزن يُكمَّل **قبل** الوصول هنا بسطر فرق
 * صريح حسب إعداد الشركة (`balanceOpeningDifference`، ADR-0006) أو يُرفض — فالفحوص
 * هنا تسرى على السطور كما ستُرحَّل فعلاً، بما فيها سطر الفرق.
 */
function checkOpeningBalance(intent, ctx) {
    const issues = [];
    if (intent.postingDate !== ctx.fiscalPeriod.startDate) {
        issues.push({
            code: 'OPENING_DATE_NOT_PERIOD_START',
            message: 'an opening balance is dated on the first day of its fiscal period (' +
                ctx.fiscalPeriod.startDate +
                ')',
            details: { expected: ctx.fiscalPeriod.startDate, actual: intent.postingDate },
        });
    }
    const expectedSource = openingSourceId(ctx.fiscalPeriod.startDate);
    if (intent.sourceId !== expectedSource) {
        issues.push({
            code: 'OPENING_SOURCE_MISMATCH',
            message: 'an opening balance uses source id ' + expectedSource,
            details: { expected: expectedSource, actual: intent.sourceId ?? '' },
        });
    }
    intent.lines.forEach((line, lineIndex) => {
        const account = ctx.accounts.get(line.accountCode);
        if (account && account.statement !== 'BS') {
            issues.push({
                code: 'OPENING_NON_BS_ACCOUNT',
                message: 'account ' +
                    account.code +
                    ' is a profit-and-loss account; openings carry balance-sheet accounts only',
                lineIndex,
                accountCode: account.code,
            });
        }
    });
    return issues;
}
//# sourceMappingURL=opening-balance.js.map